<template>
  <div
    class="main--text">
    <v-row
      justify=center>
      <v-col
        cols=auto>
        <v-card
          width=800>
          <v-container
            fluid
            >
            <v-row
              align="center"
              justify="space-between"
              no-gutters
              >
              <v-col
                cols=auto>
                <span class="font-weight-bold" style="font-size:1.3rem">{{ student.fullName() }}</span><span class="font-weight-bold"> さん </span>
                <v-icon
                small
                @click="$emit('edit-button-click')">fa-edit</v-icon>
              </v-col>
              <v-col
                cols=auto>
                <v-icon
                  @click="toStudents">mdi-arrow-left-circle</v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-list
                  two-line>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        性別
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ student.genderInJapanese() }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        生年月日
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ student.birthdayToString() }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        学年
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ student.grade().toJapanese() }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </v-col>
            </v-row>
            <v-row
              no-gutters>
              <v-col>
                <v-subheader>希望時間帯</v-subheader>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols=auto>
                  <v-chip
                    v-for="(schedule, index) in student.availableSchedulesToStrings()"
                    :key="index"
                    outlined>{{schedule}}</v-chip>
              </v-col>
            </v-row>
            <v-row
              no-gutters>
              <v-col
                v-if="teachers.length()">
                <v-subheader>授業を依頼できる先生（クリックで詳細表示）</v-subheader>
              </v-col>
            </v-row>
            <v-row
              dense
              >
              <v-col
                v-for="(teacher, index) in teachers.get()"
                :key="index"
                cols=auto
                >
                <v-tooltip top>
                  <template
                    v-slot:activator="{ on }">
                      <v-avatar
                        v-on="on"
                        @click="$emit('teacher-avatar-click', teacher)"
                        style="cursor:pointer"
                        >
                        <img :src="teacher.iconUrl" alt="" >
                      </v-avatar>
                  </template>
                    {{teacher.fullName()}}
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row
              no-gutters
              v-if="student.lessons.get().length > 0">
              <v-col>
                <v-subheader>授業スケジュール</v-subheader>
              </v-col>
            </v-row>
            <template
              v-for="(lesson) in student.lessons.get()">
              <v-lesson-schedule
                :key="lesson.id"
                :lesson="lesson"
                :teacher="teachers.find(lesson.teacherId)"
                @input-button-click="openRecord"
                @delete-button-click="deleteLesson"/>
            </template>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      width="600"
      persistent
      :value="recordDialog">
      <v-record-lesson-card
        v-if="lesson && teacher"
        :lesson="lesson"
        :teacher="teacher"
        :student="student"
        @close-button-click="recordDialog=false"
      />
    </v-dialog>
  </div>
</template>

<script>
import VLessonSchedule from "@/components/organisms/parent/VLessonSchedule"
import VRecordLessonCard from "@/components/organisms/parent/VRecordLessonCard.vue"

export default {
  components: {
    VLessonSchedule,
    VRecordLessonCard
  },
  props: {
    student: {
      type: Object
    },
    teachers: {
      type: Object
    }
  },
  data () {
    return {
      isRegisterRecord: false,
      lesson: null,
      teacher: null,
      recordDialog: false
    }
  },
  methods: {
    toStudents () {
      this.$router.push({name: "students", params: {'id': this.$store.getters.parent.uuid}})
    },
    openRecord(lesson, teacher) {
      this.lesson = lesson
      this.teacher = teacher
      this.recordDialog = true
    },
    deleteLesson(lessonId) {
      this.$emit('delete-lesson-button-click', lessonId)
    }
  }
}
</script>
